import React from 'react';
import { Box } from '@mui/material';
import { Button } from '@elements';
import { colors } from '@themes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var DayPickerActionBarComponent = function DayPickerActionBarComponent(_ref) {
  var handleOpen = _ref.handleOpen,
      value = _ref.value,
      isShowButtons = _ref.isShowButtons,
      onChange = _ref.onChange;

  var handleAccept = function handleAccept(event) {
    handleOpen(event);
    onChange({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      target: {
        value: value
      }
    });
  };

  var handleCancel = function handleCancel(event) {
    handleOpen(event);
    onChange({
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      target: {
        value: null
      }
    });
  };

  return /*#__PURE__*/_jsxs(Box, {
    position: "absolute",
    bottom: "4px",
    right: "12px",
    display: isShowButtons ? 'block' : 'none',
    children: [/*#__PURE__*/_jsx(Button, {
      variant: "text",
      onClick: handleCancel,
      children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
    }), /*#__PURE__*/_jsx(Button, {
      variant: "text",
      color: "internationalOrange",
      onClick: handleAccept,
      sx: {
        color: "".concat(colors.internationalOrange, " !important")
      },
      children: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C"
    })]
  });
};

export { DayPickerActionBarComponent };